import { GameEngine } from '../game-engine-helper';
import { GamePhase } from '../../app/types';
import { SFSObject } from 'sfs2x-api';
import { SFSVAR, getSFSTrue } from '../sfsVar';
import { TableInfo } from '../../slices/tableSlice';
import { bridgeWarGui, environment } from '../../env';
import { getStringContract, getStringDeclarer } from '../sfsObjectConverter';

export function MID_CONTRACT(cmdObj: SFSObject, sender: GameEngine) {
    sender.props.table_updateBiddingLadder({
        isVisible: false,
    });
    update_contract({ cmdObj: cmdObj, sender: sender });
}

export function update_contract({ cmdObj, sender }: { cmdObj: SFSObject; sender: GameEngine }) {
    const gameState: SFSObject | undefined = cmdObj.containsKey('tablestate')
        ? cmdObj.getSFSObject('tablestate')
        : undefined;
    const contract: SFSObject | undefined = gameState?.containsKey('contract')
        ? gameState.getSFSObject('contract')
        : cmdObj.containsKey('contract')
        ? cmdObj.getSFSObject('contract')
        : undefined;
    const goal: number = (contract?.getInt('level') ?? 0) + 6;
    sender.props.table_setTrickCounts({
        ns: 0,
        ew: 0,
        goal: cmdObj.getInt('goal') ?? gameState?.getInt('goal') ?? goal,
    });

    if (!contract) {
        return;
    }

    if (sender.props.app.engineStateInterface.isMiniBridge || getSFSTrue(gameState, SFSVAR.SFSGAME_NOAUCTION)) {
        sender.props.table_setShowAuctionLine(false);
    } else {
        sender.props.table_setShowAuctionLine(environment === 'audrey');
    }

    if (environment === 'audrey') {
        const completeAuction = contract.getInt('declarer') >= 0;

        if (contract.getBool('passed') || !completeAuction) {
            return;
        }

        sender.props.table_updateTable({
            showTrickCounter: environment,
        });

        const rightinfo: TableInfo[] = [];
        rightinfo.push({
            label: 'Contract: ',
            value: getStringContract(contract),
            hidden: false,
        });
        rightinfo.push({
            label: 'Declarer: ',
            value: getStringDeclarer(contract),
            hidden: false,
        });
        sender.props.table_setTableInfo({ left: sender.props.table.tableInfo.left, right: rightinfo });
    } else {
        if (!bridgeWarGui && environment === 'shark') {
            sender.props.table_setComponentContainerPositions({
                BiddingKeyboardComponent: 'none',
                AuctionBoxComponent: 'topLeft',
                TableSymbolComponent: 'none',
            });
            sender.props.table_updateTable({
                gamePhase: GamePhase.PLAY,
            });
            sender.props.table_setShowTrickCounter('shark');
        } else if (bridgeWarGui) {
            sender.setContractFromSFSObject(contract);
            sender.props.table_setComponentContainerPositions({
                BiddingKeyboardComponent: 'none',
                AuctionBoxComponent: 'none',
            });
        }
    }
    sender.setContractFromSFSObject(contract);
}
